<template>
    <div>
        <div class="container">
            <CommonBreadcrumb class="my-3"/>
        </div>
        <div class="video_box">
            <video @contextmenu.prevent="" controlsList="nodownload" loop muted autoplay playsinline width="1920" height="540">
                <source src="https://assets.friendlydiamonds.com/fdl/static-video/banner_cropped.mp4" type="video/mp4">
            </video>
            <div class="video_text">
                <div class="text text-center">
                    <h1 class="font-active">The ‘Friendly’ Evolution</h1>
                    <h4 class="mb-0">FOR A FRIENDLIER TOMORROW</h4>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row align-items-center mt-4 mt-md-5 mb-5 block">
                <div class="col-12 col-lg-6 content">
                    <div class="year mb-3">2017</div>
                    <h5 class="font-active mb-3">The Start Of Our Journey</h5>
                    <p>Our dreams of starting <i>Friendly Diamonds</i> began in the summer of 2017 in New York. Since then, we have completed thousands of lab-diamond engagement rings and jewelry orders; each created while keeping in mind the unique desires of our customers and friendly spirit towards the environment. </p>
                    <p>It all started with a vision- to make the process of finding the perfect diamond or jewelry less intimidating, and more <i class="words">friendly</i>. This led us to lab grown diamonds- a friendly alternative that is guilt-free, ethical, and never-mined. </p>
                    <p>We aimed to stay friendly to the community, friendly to the environment, and friendly to <i>YOU.</i></p>
                    <P><b><i class="words">Welcome to Friendly Diamonds, where our name isn't just a label; it's a promise, a commitment, and a declaration of our ethos.</i></b></P>
                </div>
                <div class="col-12 col-lg-6">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/our_story/image1.webp">
                        <img alt="How are lab diamonds made" loading="lazy" width="1240" height="1280" type="image/jpeg" src="~/assets/our_story/image1.jpg">
                    </picture>
                </div>
            </div>
    
            <div class="row align-items-center mb-5 block">
                <div class="col-12 col-lg-6 content">
                    <div class="year mb-3">2018</div>
                    <h5 class="font-active mb-3">Spreading The Sparkle Online</h5>
                    <p>In 2018 we hit the ground running by offering a hand-picked selection of exquisite fine jewelry on popular online marketplaces such as Amazon, eBay, Walmart, and more. This step allowed us to reach a broader audience across the USA and Canada. </p>
                    <p>This was a milestone moment for us as we got to learn the ropes of online sales and build a foundation for our future growth.</p>
                    <p><b><i class="words">Our goal at Friendly Diamonds is to make diamonds as accessible and ethical as possible</i></b></p>
                </div>
                <div class="col-12 col-lg-6 ">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/our_story/image2.webp">
                        <img alt="How are lab diamonds made" loading="lazy" width="1240" height="1280" type="image/jpeg" src="~/assets/our_story/image2.jpg">
                    </picture>
                </div>
            </div>
    
            <div class="row align-items-center mb-5 block">
                <div class="col-12 col-lg-6 content">
                    <div class="year mb-3">2020</div>
                    <h5 class="font-active mb-3">Personalization, Customization, And A Website…</h5>
                    <p>While marketplaces  provided us with invaluable exposure, they also revealed a lack of personalization. The global pandemic presented its own share of challenges, but we persevered and launched our own website by the end of the year. </p>
                    <p>Our cursive <i>‘Friendly Diamonds’</i>&nbsp logo was crafted to convey the approachability, ease, and effortless charm that defined our brand. We decided on red as it is the color of love and represents our passion for helping you express love through diamonds. </p>
                    <p>We also launched our <i class="words"> ‘Create Your Own Engagement Ring’ </i> &nbspfeature. The concept was a rarity in the world of diamonds, where crafting the ring of your dreams was made delightfully effortless online.</p>
                    <p><b><i class="words">Friendly Diamonds is determined to become your first and final destination for extraordinary engagement rings.</i></b></p>
                </div>
                <div class="col-12 col-lg-6 ">
                    <video @contextmenu.prevent="" controlsList="nodownload" loop muted autoplay playsinline width="2880" height="1800">
                        <source src="https://assets.friendlydiamonds.com/fdl/static-video/old_website.mov" type="video/mp4">
                    </video>
                </div>
            </div>
    
            <div class="row align-items-center mb-5 block">
                <div class="col-12 col-lg-6 content">
                    <div class="year mb-3">2021</div>
                    <h5 class="font-active mb-3">The Friendly Family Blossomed</h5>
                    <p>Our journey, marked by determination and passion, led us to a pivotal moment: the blossoming of the <i class="words">Friendly Family.</i> With every engagement ring crafted, we were not just creating a piece of ornament; we were becoming an integral part of people&apos;s lives and love stories.</p>
                    <p>And as these moments unfolded, our family grew—from a mere idea to a vibrant community of 5000+ happy couples, and counting.</p>
                    <p><b><i class="words">The journey of Friendly Diamonds is a testament to the power of connection, the beauty of love, and the trust our customers placed in us.</i></b></p>
                </div>
                <div class="col-12 col-lg-6 ">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/our_story/image4.webp">
                        <img alt="How are lab diamonds made" loading="lazy" width="1239" height="1151" type="image/jpeg" src="~/assets/our_story/image4.jpg">
                    </picture>
                </div>
            </div>
    
            <div class="row align-items-center mb-5 block">
                <div class="col-12 col-lg-6 content">
                    <div class="year mb-3">2022</div>
                    <h5 class="font-active mb-3">New Year, New Us</h5>
                    <p>2022 was the year of growth at Friendly Diamonds. We were determined to be <i class="words">Earth-kind in every possible way.</i> We wanted our online presence to reflect our vision, and decided to undergo a complete metamorphosis; we rebranded our logo and website to mirror our evolution- sleek, bold &amp; green. This refresh was more than a makeover; it was a celebration of who we were <i class="words">becoming.</i></p>
                    <p>Our new logo featuring a bird with spread wings reminds us of the interconnectedness of all life- a recognition that our actions have a ripple effect on the world around us. We aimed to approach every decision with immense care, honoring the sanctity of all living beings and their ecosystems</p>
                    <p>The color <i class="words">green</i> spoke best of our mindful choices, of nurturing our planet and of embracing the cyclical nature of life. In choosing green, we sought to embody Earth-centric principles in every aspect of our brand.</p>
                </div>
                <div class="col-12 col-lg-6 ">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/our_story/image5.webp">
                        <img alt="How are lab diamonds made" loading="lazy" width="1240" height="1280" type="image/jpeg" src="~/assets/our_story/image5.jpg">
                    </picture>
                </div>
            </div>
    
            <div class="row align-items-center mb-5 block">
                <div class="col-12 col-lg-6 content">
                    <div class="year mb-3">2023</div>
                    <h5 class="font-active mb-3">From Vision To Action: Our Stepping Stone For CSR</h5>
                    <p>Launching Friendly Diamonds anew was major for us, but we knew we had to use our platform for more. We were passionately driven by a deep-rooted belief in the power of giving back to our community & planet.</p>
                    <p>In collaboration with <b>Abundant Life Ministry</b>, an NGO we helped uplift orphans in India by providing for their accommodation, nutrition and education. Through educational sponsorships, we strive to provide opportunities for learning and growth, paving the way for their brighter future. <NuxtLink :to="localePath({ name:'our-share-of-care'})">Discover Our Impact On Young Lives.</NuxtLink></p>
                    <p>As part of our initiative to minimize our carbon footprint and create a friendlier tomorrow, we even collaborated with <b>Evertreen</b>- an NGO dedicated to reforestation. Together we sow the seeds of new trees in the different regions of Africa for every purchase made on our website. <NuxtLink :to="localePath({ name:'green-and-sustainable-gift'})"v-if="!$country.is_india">Explore Our Green Initiatives.</NuxtLink></p>
                </div>
                <div class="col-12 col-lg-6 ">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/our_story/image6.webp">
                        <img alt="How are lab diamonds made" loading="lazy" width="1240" height="1280" type="image/jpeg" src="~/assets/our_story/image6.jpg">
                    </picture>
                </div>
            </div>
    
            <div class="row align-items-center mb-5 block" v-if="$country.is_india">
                <div class="col-12 col-lg-6 content">
                    <div class="year mb-3">2024</div>
                    <h5 class="font-active mb-3">Our Desi Detour</h5>
                    <p>Our mission to make diamonds accessible transcended borders, leading us to explore the engagement ring market in India. </p>
                    <p>Why India? Because we observed a cultural landscape where proposals and love stories often didn&apos;t receive the spotlight they deserved. Recognizing this unmet need, we envisioned a future where the rich tapestry of Indian traditions seamlessly merged with the grandeur of Western customs, culminating in unforgettable moments of love and commitment.</p>
                    <p>This catalyzed the start of our <i class="words">Desi Detour</i> in early 2024 as we launched our Indian website.</p>
                    <p><b><i class="words">Our aim is to ignite a cultural shift in India—one where proposals became cherished milestones, celebrated with the same fervor and joy as the Great Indian Weddings themselves.</i></b></p>
                </div>
                <div class="col-12 col-lg-6 ">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/our_story/image7.webp">
                        <img alt="How are lab diamonds made" loading="lazy" width="1240" height="1280" type="image/jpeg" src="~/assets/our_story/image7.jpg">
                    </picture>
                </div>
            </div>
    
            <div class="row align-items-center mb-5 block">
                <div class="col-12 col-lg-6 content">
                    <h5 class="font-active mb-3">As of Now..</h5>
                    <p>As our journey continues, we remain committed to our vision of creating a <i class="words">friendlier tomorrow.</i> We are always on the lookout for new opportunities to serve our community and environment better by making a positive impact while becoming completely carbon-neutral. </p>
                    <p>Our story is far from over; it&apos;s a journey of endless possibilities and boundless potential. With every step we take, we strive to spread joy, sparkles, and kindness, making the world a brighter place one diamond at a time.</p>
                    <p>Join us in our journey towards a more compassionate, sustainable, and equitable world.</p>
                    <p><b><i class="words">The best is yet to come…</i></b></p>
                </div>
                <div class="col-12 col-lg-6 ">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/our_story/image8.webp">
                        <img alt="How are lab diamonds made" loading="lazy" width="1240" height="1280" type="image/jpeg" src="~/assets/our_story/image8.jpg">
                    </picture>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    
    <script setup>
        useFetchMeta( useNuxtApp(), useRuntimeConfig() );
        const localePath = useLocalePath();
        const { $country } = useNuxtApp();
    </script>
    
    
    
    <style scoped>
    video {
        max-width: 100%;
        height: auto;
        clip-path: inset(0);
    }
    .video_box {
        position: relative;
    }
    .video_text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }
    
    .text h1 {
        font-size: 60px;
        color: #ffffff;
    }
    .text h4 {
        font-size: 24px;
        letter-spacing: 4px;
        color: #ffffff;
    }

    .content {
        padding-right: 4%;
    }
    
    .content .year {
        font-size: 18px;
        letter-spacing: 4px;
        color: #9d7a5a;
    }
    .content h5 {
        font-size: 32px;
        color: #212529;
    }
    
    .content p {
        font-size: 16px;
        color: #606060;
    }
    
    .content .words {
        color: var(--green);
    }
    
    .content a {
        color: var(--green);
        text-decoration: underline;
    }
    
    .block img {
        border-radius: 8px;
    }
    
    .block video {
        border-radius: 12px;
        border-left: 8px solid #000;
        border-right: 8px solid #000;
    }

   
    
    @media(max-width: 1200px) {
        .text h1 {
            font-size: 50px;
        }
        .text h4 {
            font-size: 22px;
            letter-spacing: 3px;
        }
        .content h5 {
            font-size: 30px;
        }
    }
    
    @media(max-width:991px) {
        .text h1 {
            font-size: 40px;
        }
        .text h4 {
            font-size: 20px;
            letter-spacing: 2px;
        }
        .content h5 {
            font-size: 28px;
        }
    }
    
    @media(max-width:767px) {
        .video_box video {
            height: 60vh ;
            object-fit: cover;
        }
        .block {
            flex-direction: column-reverse;
            margin-bottom: 40px !important
        }
        .block img {
            margin-bottom: 16px;
        }
        .block video {
            margin-bottom: 16px;
        }
        .text h1 {
            font-size: 24px;
        }
        .text h4 {
            font-size: 12px;
            letter-spacing: 1.5px;
        }
        .content .year {
            font-size: 16px;
        }
        .content h5 {
            font-size: 24px;
        }
        .content p {
            font-size: 14px;
        }
        .block img {
             border-radius: 4px;
        }
    
    }
    </style>